export const ACTIVATE_EARLY_REPAYMENT = 'page/EARLY_REPAYMENT [activate]';
export const LEAVE_EARLY_REPAYMENT = 'page/EARLY_REPAYMENT [leaving]';

export const EARLY_REPAYMENT_READY = 'page/EARLY_REPAYMENT [done]';
export const EARLY_REPAYMENT_LOADING = 'page/EARLY_REPAYMENT [loading]';

export const REQUEST_NEW_REPAYMENT_SCHEDULE_TO_REPAY =
    'page/NEW_REPAYMENT_SCHEDULE_TO_REPAY [request]';
export const REQUEST_NEW_REPAYMENT_SCHEDULE_TO_REPAY_LOADING =
    'page/NEW_REPAYMENT_SCHEDULE_TO_REPAY [loading]';
export const UPDATE_REPAYMENT_SCHEDULE_EARLY_REPAYMENT =
    'page/UPDATE_REPAYMENT_SCHEDULE_EARLY_REPAYMENT';

export const SHOW_CHOOSE_REPAYMENT_AMOUNT_STEP =
    'page/EARLY_REPAYMENT_CHOOSE_REPAYMENT_AMOUNT [show]';
export const SHOW_CONFIRM_REPAYMENT_STEP =
    'page/EARLY_REPAYMENT_CONFIRM_REPAYMENT [show]';

export const EARLY_REPAYMENT_ACCOUNT_ID = 'page/EARLY_REPAYMENT_ACCOUNT_ID';

export const EARLY_REPAYMENT_CHOOSE_REPAYMENT_AMOUNT_DATA =
    'page/CHOOSE_REPAYMENT_AMOUNT [done]';
export const EARLY_REPAYMENT_CONFIRM_REPAYMENT_DATA =
    'page/CONFIRM_REPAYMENT [done]';

export const UPDATE_CONFIRM_REPAYMENT_SCHEDULE_EARLY_REPAYMENT =
    'page/UPDATE_CONFIRM_REPAYMENT_SCHEDULE_EARLY_REPAYMENT';
export const CONFIRM_EARLY_REPAYMENT = 'page/CONFIRM_EARLY_REPAYMENT';
export const CONFIRM_EARLY_REPAYMENT_LOADING =
    'page/CONFIRM_EARLY_REPAYMENT [loading]';

export const UPDATE_SELECTED_REPAYMENT_AMOUNT =
    'page/UPDATE_SELECTED_REPAYMENT_AMOUNT';

export const SELECT_REPAYMENT_METHOD = 'page/SELECT_REPAYMENT_METHOD';
export const DEBIT_CARD_REPAYMENT = 'page/DEBIT_CARD_REPAYMENT';

export const TRUELAYER_REPAYMENT = 'page/TRUELAYER_REPAYMENT';
export const ACCEPT_TRUELAYER_REDIRECT = 'page/ACCEPT_TRUELAYER_REDIRECT';
export const SHOW_TRUELAYER_CONFIRMATION = 'page/SHOW_TRUELAYER_CONFIRMATION';
export const TRUELAYER_REDIRECT_BACK_TO_PAYMENT_CONFIRMATION =
    'page/TRUELAYER_REDIRECT_BACK_TO_PAYMENT_CONFIRMATION';
